import React from 'react';

class InfoRead extends React.Component {
    render() {
        return (
            <div className = 'dms-body' >
                {this.props.children}
            </div>
        )
    }
};
export default InfoRead;



// WEBPACK FOOTER //
// ./src/routes/infoRead/index.js